module.exports = __webpack_public_path__ + "images/jawa_small37909adfa2be07d379748ac1f366c9ab.png";